var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',{attrs:{"trigger":_vm.trigger,"visible":_vm.optionsVisible},on:{"visibleChange":_vm.handleClickChange}},[_c('template',{slot:"content"},[_c('div',{on:{"click":function($event){return _vm.handleClickChange(false)}}},[_vm._t("content")],2)]),_c('span',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }